import type { FC } from 'react';
import { SvgWrapper, type SvgWrapperProps } from '../SvgWrapper/SvgWrapper';

/**
 * Decorative icon showing a color palette with clouds
 * Used in intent verification default color selection
 */
export const ColorPaletteIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 71 71' {...props}>
    <g clipPath='url(#a)'>
      <path
        fill='#E1EFFE'
        stroke='#9CF'
        strokeWidth='1.012'
        d='M3.075 54.261a5.151 5.151 0 0 1 4.542-2.716L3.075 54.26zm0 0a5.153 5.153 0 0 0 4.542 7.59h17.13a3.945 3.945 0 0 0 .97-7.77l-.395-.101m-22.247.281 22.247-.281m0 0 .014-.408m-.014.408.014-.408m0 0 .003-.065.002-.053a8.401 8.401 0 0 0-12.442-7.363m12.437 7.481L12.9 46.092m0 0a8.419 8.419 0 0 0-4.052 5.13l-.117.424m4.17-5.554-4.17 5.554m0 0-.436-.056m.436.056-.436-.056m0 0a5.258 5.258 0 0 0-.677-.045l.677.045z'
      />
      <path
        fill='#CCE5FF'
        d='M25.877 57.906a4.454 4.454 0 0 0-3.358-4.316c.002-.045.005-.09.005-.136 0-4.326-3.086-7.93-7.176-8.736-.023-.005-.047-.008-.07-.012a8.945 8.945 0 0 1 3.393.012c4.09.805 7.175 4.41 7.175 8.736 0 .046-.003.091-.004.136a4.451 4.451 0 0 1-1.095 8.767h-3.323a4.451 4.451 0 0 0 4.453-4.45z'
      />
      <path
        fill='#E1EFFE'
        stroke='#9CF'
        strokeWidth='1.012'
        d='m40.957 30.585.011.405-.393.1a4.954 4.954 0 0 0 1.22 9.758h21.011a6.437 6.437 0 1 0 0-12.872c-.284 0-.564.02-.844.057l-.437.058-.117-.425c-1.13-4.114-4.718-7.209-9.083-7.605a10.37 10.37 0 0 0-7.56 2.318 10.434 10.434 0 0 0-3.348 4.965 10.441 10.441 0 0 0-.463 3.166l.003.075z'
      />
      <path
        fill='#CCE5FF'
        d='M64.527 34.411a6.921 6.921 0 0 0-1.835-4.703 6.925 6.925 0 0 0-6.018-2.177 10.936 10.936 0 0 0-7.914-7.704 10.926 10.926 0 0 1 3.61-.27c4.58.416 8.34 3.66 9.526 7.974a6.926 6.926 0 0 1 6.017 2.177 6.943 6.943 0 0 1-5.108 11.645l-5.22.001a6.943 6.943 0 0 0 6.942-6.943z'
      />
      <path
        fill='#44BB85'
        d='M12.588 43.846c0 .606.023 1.207.068 1.802a8.852 8.852 0 0 1 4.286-1.098c.592 0 1.17.059 1.73.168-.015-.29-.023-.58-.023-.872 0-9.589 7.772-17.36 17.36-17.36 1.711 0 3.365.246 4.925.708a10.94 10.94 0 0 1 3.51-5.207 23.383 23.383 0 0 0-8.434-1.563c-12.937 0-23.422 10.485-23.422 23.422z'
      />
      <path
        fill='#FEC84B'
        d='M6.727 43.846c0 2.481.308 4.89.89 7.193a5.7 5.7 0 0 1 .743.05 8.924 8.924 0 0 1 4.296-5.44 24.27 24.27 0 0 1-.069-1.803c0-12.936 10.486-23.422 23.423-23.422a23.4 23.4 0 0 1 8.434 1.563 10.877 10.877 0 0 1 7.927-2.43 29.138 29.138 0 0 0-16.361-4.994c-16.172 0-29.283 13.11-29.283 29.283z'
      />
      <path
        fill='#F05252'
        d='M1.122 43.846c0 3.54.527 6.957 1.508 10.176a5.657 5.657 0 0 1 4.987-2.983 29.303 29.303 0 0 1-.89-7.193c0-16.172 13.11-29.283 29.283-29.283 6.06 0 11.69 1.84 16.36 4.994 4.58.416 8.34 3.661 9.526 7.974a6.926 6.926 0 0 1 6.017 2.177C62.49 17.485 50.244 8.959 36.01 8.959c-19.268 0-34.888 15.62-34.888 34.888z'
      />
    </g>
  </SvgWrapper>
);
